import { Injectable, inject } from '@angular/core';
import { Firestore, collection, addDoc, query, orderBy, doc, updateDoc, deleteDoc, onSnapshot } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

export interface Account {
  id?: string;
  code: string;
  name: string;
  category: string; // e.g. Asset, Liability, Revenue
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private firestore = inject(Firestore);
  private accountsCollection = collection(this.firestore, 'chart_of_account');

  getAccounts(): Observable<Account[]> {
    // Sort accounts by their code (1000, 1010, 2000...)
    const q = query(this.accountsCollection, orderBy('code', 'asc'));
    return new Observable<Account[]>(observer => {
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const accounts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Account));
        observer.next(accounts);
      }, (error) => observer.error(error));
      return unsubscribe;
    });
  }

  // Helper to add data
  async addAccount(account: Account) {
    return addDoc(this.accountsCollection, account);
  }

  async updateAccount(id: string, account: Partial<Account>) {
    const docRef = doc(this.firestore, 'chart_of_account', id);
    return updateDoc(docRef, account);
  }

  async deleteAccount(id: string) {
    const docRef = doc(this.firestore, 'chart_of_account', id);
    return deleteDoc(docRef);
  }
}